import { Reveal } from "@/components/okaia/Reveal";

const RISKS = [
  "Multiplier les recherches sans décider",
  "Repousser les décisions importantes",
  "Investir du temps et de l'argent dans une solution inadaptée",
];

export const Editorial = () => (
  <section data-testid="section-editorial" className="bg-[#F0EBE1] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="okaia-overline mb-6 text-[#B39265]">Le constat</p>
            <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
              Pourquoi est-il si difficile de choisir la bonne solution&nbsp;?
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.15}>
            <p className="font-serif-display text-xl italic leading-relaxed text-[#0B2215] md:text-2xl">
              Aujourd'hui, les solutions ne manquent pas. Le plus difficile est de savoir ce qui
              correspond réellement à votre situation.
            </p>
            <ul className="mt-8 space-y-4">
              {RISKS.map((r, i) => (
                <li key={i} className="flex items-center gap-4 border-b border-[#0B2215]/10 pb-4 text-base font-light text-[#4A5A52]">
                  <span className="font-serif-display text-sm italic text-[#C8A97E]">0{i + 1}</span>
                  {r}
                </li>
              ))}
            </ul>
            <p className="mt-8 font-medium text-[#0B2215]">
              Avant d'avancer&nbsp;: clarifier sa situation, ses objectifs et ses priorités.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
